var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: { title: _vm.dialogTitle, isShowFollow: false },
              on: { open: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c(
                  "el-form",
                  {
                    ref: "filterFormRef",
                    attrs: {
                      rules: _vm.filterFormRules,
                      model: _vm.filterForm,
                    },
                  },
                  [
                    _c(
                      "el-row",
                      {
                        staticStyle: { position: "relative" },
                        attrs: { gutter: 1 },
                      },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                staticStyle: { "margin-bottom": "15px" },
                                attrs: {
                                  prop: "copyCount",
                                  label: _vm.$t("home.copyNumber") + "：",
                                },
                              },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    "auto-cut": true,
                                    controls: false,
                                    disabled: _vm.inputDisable,
                                    min: 1,
                                  },
                                  model: {
                                    value: _vm.filterForm.copyCount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterForm,
                                        "copyCount",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "filterForm.copyCount",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c("el-form-item", { attrs: { prop: "bkType" } }, [
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "28px" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { disabled: _vm.inputDisable },
                                      model: {
                                        value: _vm.filterForm.bkType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterForm,
                                            "bkType",
                                            $$v
                                          )
                                        },
                                        expression: "filterForm.bkType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: {
                                            label: "0",
                                            disabled: _vm.bkTypeDisabled,
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("home.copyTwo")))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: {
                                            label: "1",
                                            disabled: _vm.podAndDel,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("home.copyThree"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.newReportSearchForm.confirmFlag !==
                                        1 ||
                                      _vm.newReportSearchForm
                                        .spliteCombinType !== 0
                                        ? _c(
                                            "el-radio",
                                            {
                                              attrs: {
                                                label: "2",
                                                disabled: _vm.bkTypeDisabled,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("home.copyFour"))
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn-primary",
                                staticStyle: { "margin-top": "28px" },
                                attrs: { type: "primary" },
                                on: { click: _vm.inputBlur },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("home.sureButton")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 3, offset: 3 } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "34px",
                                "text-align": "right",
                                "margin-right": "2%",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form-add-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.addTableData()
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-plus" }),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("home.addTicket")) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "table-container-new-back",
                      staticStyle: { width: "100%" },
                    },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "tableFormRef",
                          attrs: {
                            rules: _vm.tableRules,
                            model: _vm.dialogTableDataForm,
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              ref: "multipleTable",
                              attrs: {
                                data: _vm.dialogTableDataForm.dialogTableData,
                              },
                            },
                            [
                              _c(
                                "el-table-column",
                                {
                                  attrs: { prop: "bkNo" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "15px",
                                              },
                                              attrs: {
                                                prop:
                                                  "dialogTableData." +
                                                  scope.$index +
                                                  ".bkNo",
                                                rules: _vm.tableRules.bkNo,
                                              },
                                            },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    "popper-class":
                                                      "custom-tooltip-popper",
                                                    effect: "light",
                                                    content: scope.row.bkNo,
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      maxlength: "18",
                                                      disabled:
                                                        (scope.row.isBlBk ==
                                                          false &&
                                                          _vm.inputDisable) ||
                                                        _vm.bkBlNoDisabled,
                                                    },
                                                    model: {
                                                      value: scope.row.bkNo,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "bkNo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.bkNo",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _c("template", { slot: "header" }, [
                                    _c(
                                      "span",
                                      { staticClass: "required-marker" },
                                      [_vm._v(" *")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "required-marker" },
                                      [_vm._v(_vm._s(_vm.$t("home.bkNo")))]
                                    ),
                                  ]),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "el-table-column",
                                {
                                  attrs: { prop: "blNo" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "15px",
                                              },
                                              attrs: {
                                                prop:
                                                  "dialogTableData." +
                                                  scope.$index +
                                                  ".blNo",
                                                rules: _vm.tableRules.blNo,
                                              },
                                            },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    "popper-class":
                                                      "custom-tooltip-popper",
                                                    effect: "light",
                                                    content: scope.row.blNo,
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      maxlength: "18",
                                                      disabled:
                                                        (scope.row.isBlBk ==
                                                          false &&
                                                          _vm.inputDisable) ||
                                                        _vm.bkBlNoDisabled,
                                                    },
                                                    model: {
                                                      value: scope.row.blNo,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "blNo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.blNo",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _c("template", { slot: "header" }, [
                                    _c(
                                      "span",
                                      { staticClass: "required-marker" },
                                      [_vm._v(" *")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "required-marker" },
                                      [_vm._v(_vm._s(_vm.$t("home.blNo")))]
                                    ),
                                  ]),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "vesselCode",
                                  label: _vm.$t(
                                    "booking.bookingSplit.vesselName"
                                  ),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "15px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  "popper-class":
                                                    "custom-tooltip-popper",
                                                  effect: "light",
                                                  content: scope.row.vesselCode,
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled:
                                                      scope.row.isEdit == false,
                                                    maxlength: "50",
                                                  },
                                                  model: {
                                                    value: scope.row.vesselCode,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "vesselCode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.vesselCode",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "voyageNo",
                                  label: _vm.$t("home.voyageNo"),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "15px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  "popper-class":
                                                    "custom-tooltip-popper",
                                                  effect: "light",
                                                  content: scope.row.voyageNo,
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled:
                                                      scope.row.isEdit == false,
                                                    maxlength: "50",
                                                  },
                                                  model: {
                                                    value: scope.row.voyageNo,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "voyageNo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.voyageNo",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "pol",
                                  label: _vm.$t("home.pol"),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "15px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  "popper-class":
                                                    "custom-tooltip-popper",
                                                  effect: "light",
                                                  content: scope.row.pol,
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled:
                                                      scope.row.isEdit == false,
                                                    maxlength: "50",
                                                  },
                                                  model: {
                                                    value: scope.row.pol,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "pol",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "scope.row.pol",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "timeDate", label: "ETD" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "15px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  "popper-class":
                                                    "custom-tooltip-popper",
                                                  effect: "light",
                                                  content: scope.row.timeDate,
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled:
                                                      scope.row.isEdit == false,
                                                    maxlength: "50",
                                                  },
                                                  model: {
                                                    value: scope.row.timeDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "timeDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.timeDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { width: "50" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "15px",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-remove-outline",
                                              staticStyle: {
                                                "font-size": "16px",
                                                cursor: "pointer",
                                                color: "#A9AEB8",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteTableItem(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "right",
                      margin: "20px 0 0px 0",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-info-primary",
                        staticStyle: {
                          "margin-bottom": "20px",
                          "min-width": "90px",
                          height: "30px",
                        },
                        on: { click: _vm.handleButtonClose },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("home.buttonClose")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.newReportSearchForm.confirmFlag == 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "btn-plain-primary",
                            staticStyle: {
                              "margin-bottom": "20px",
                              "min-width": "90px",
                              height: "30px",
                            },
                            attrs: {
                              disabled: _vm.newReportData.blType === "2",
                              type: "primary",
                            },
                            on: { click: _vm.handleCancent },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.cancellation")) + " ")]
                        )
                      : _c(
                          "el-button",
                          {
                            staticClass: "btn-plain-primary",
                            staticStyle: {
                              "margin-bottom": "20px",
                              "min-width": "90px",
                              height: "30px",
                            },
                            attrs: { type: "primary" },
                            on: { click: _vm.handleCancent },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("home.cancelButton")) +
                                "\n          "
                            ),
                          ]
                        ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-primary",
                        staticStyle: {
                          "margin-bottom": "20px",
                          "min-width": "90px",
                          height: "30px",
                        },
                        attrs: { type: "primary" },
                        on: { click: _vm.handleApply },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("booking.bookingSplit.applyBooking")
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }